<template>
  <a-form
    ref="form"
    :model="search"
    :style="{ marginBottom: '20px' }"
    :initialValues="search"
    :onFinish="pageSearchChange"
    layout="inline"
  >
    <a-form-item label="品牌商" name="keywords">
      <a-input
        v-model:value="search.keywords"
        style="width: 250px"
        placeholder="请输入品牌商编号/公司名称"
      ></a-input>
    </a-form-item>
    <a-form-item label="商户号" name="behalf">
      <a-input
        v-model:value="search.behalf"
        style="width: 250px"
        placeholder="请输入商户号"
      ></a-input>
    </a-form-item>
    <a-form-item label="统计时间" name="">
      <a-range-picker
        valueFormat="YYYY-MM-DD"
        format="YYYY-MM-DD"
        @change="onChange"
      />
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType="submit">搜索</a-button>
      <a-button class="ml-20" type="primary" v-has:exportFinancialPaymentsBrandStatistics="exportTable"
        >导出</a-button
      >
    </a-form-item>
  </a-form>
  <a-table
    bordered
    :data-source="dataSource"
    :columns="columns"
    :pagination="false"
    :rowKey="(record, index) => index"
    :loading="listLoading"
    class="tableFixBox"
    :scroll="{ x: 'max-content' }"
  >
    <!-- 要listLoading，是因为v-has因为key不唯一，导致record数据不会刷新，永远第一页数据 -->
    <template v-slot:mark="{ record }" v-if="!listLoading">
      <a
        v-has:substitution="
          () => {
            $router.push(
              '/financial/payments/store/statistics/substitution?id=' +
                record.brand_id +
                '&name=' +
                record.brand_company
            );
          }
        "
        href="javascript:;"
        class="ml-15"
        >代发明细</a
      >
      <a
        v-has:rechargeDetailed="
          () => {
            $router.push(
              '/financial/payments/store/statistics/recharge?id=' +
                record.brand_id +
                '&name=' +
                record.brand_company
            );
          }
        "
        class="ml-15"
        href="javascript:;"
        >充值明细</a
      >
      <a
        class="ml-15"
        v-has:consumption="
          () => {
            $router.push(
              '/financial/payments/store/statistics/consumption?id=' +
                record.brand_id +
                '&name=' +
                record.brand_company
            );
          }
        "
        href="javascript:;"
        >消耗明细</a
      >
    </template>
    <template #recharge_money>
      <span style="display: flex;">
        <div class="mt-5">充值金额</div>
        <span class="ml-10" style="display: flex; flex-direction: column;">
          <span style="margin-bottom: -12px;">
            <CaretUpOutlined
              :style="{
                fontSize: '14px',
                color: isClicked ? '#05486a' : '#bfbfbf',
              }"
              @click="sort(1)"
            />
          </span>
          <span style="margin-bottom: -12px;">
            <CaretDownOutlined
              :style="{
                fontSize: '14px',
                color: isClicked ? '#bfbfbf' : ' #05486a',
              }"
              @click="sort(2)"
            />
          </span>
        </span>
      </span>
    </template>
    <template #consume_money>
      <span style="display: flex;">
        <div class="mt-5">消耗金额</div>
        <span class="ml-10" style="display: flex; flex-direction: column;">
          <span style="margin-bottom: -12px;">
            <CaretUpOutlined
              :style="{
                fontSize: '14px',
                color: isClickedtwo ? '#05486a' : '#bfbfbf',
              }"
              @click="consume(1)"
            />
          </span>
          <span style="margin-bottom: -12px;">
            <CaretDownOutlined
              :style="{
                fontSize: '14px',
                color: isClickedtwo ? '#bfbfbf' : ' #05486a',
              }"
              @click="consume(2)"
            />
          </span>
        </span>
      </span>
    </template>
    <template #replace_bonus_money>
      <span style="display: flex;">
        <div class="mt-5">代发金额</div>
        <span class="ml-10" style="display: flex; flex-direction: column;">
          <span style="margin-bottom: -12px;">
            <CaretUpOutlined
              :style="{
                fontSize: '14px',
                color: isClickedthree ? '#05486a' : '#bfbfbf',
              }"
              @click="issuing(1)"
            />
          </span>
          <span style="margin-bottom: -12px;">
            <CaretDownOutlined
              :style="{
                fontSize: '14px',
                color: isClickedthree ? '#bfbfbf' : ' #05486a',
              }"
              @click="issuing(2)"
            />
          </span>
        </span>
      </span>
    </template>
  </a-table>
  <a-pagination
    :style="{ marginTop: '20px', textAlign: 'right' }"
    show-size-changer
    show-quick-jumper
    :current="search.page"
    :page-size="search.limit"
    :total="total"
    @change="pageCurrentChange"
    @showSizeChange="pageSizeChange"
    :show-total="(total) => `总数: ${total} `"
  />
</template>

<script>
import { CaretUpOutlined, CaretDownOutlined } from "@ant-design/icons-vue";
import { ref, onMounted, reactive, toRefs } from "vue";
import {
  getBrandBillsType,
  getDillStatistics,
  exportBillStatistics,
} from "@/api/financial";
import { $iscode } from "@/utils/app";
import config from "@/config";
import { message } from "ant-design-vue";
let defSearch = {
  keywords: "",
  behalf: "",
  page: 1,
  limit: 10,
  start_time: "",
  end_time: "",
  sort_recharge_money: "",
  sort_consume_money: "",
  sort_replace_bonus_money: "",
};
export default {
  name: "brandList",
  components: { CaretUpOutlined, CaretDownOutlined },
  setup(props) {
    let search = ref({ ...defSearch });
    let total = ref(1);
    const state = reactive({
      typeLits: [],
      dataSource: [],
      listLoading: false,
      isClicked: false,
      isClickedtwo: false,
      isClickedthree: false,
      columns: [
        {
          title: "品牌商编号",
          dataIndex: "brand_id",
          key: "brand_id",
        },
        {
          title: "公司名称",
          dataIndex: "brand_company",
          key: "brand_company",
        },
        {
          title: "代发商户号",
          dataIndex: "behalf_mch_name",
          key: "behalf_mch_name",
        },
        {
          dataIndex: "recharge_money",
          key: "recharge_money",
          slots: { title: "recharge_money", customRender: "recharge_moneys" },
        },
        {
          dataIndex: "consume_money",
          key: "consume_money",
          slots: { title: "consume_money", customRender: "consume_moneys" },
        },
        {
          dataIndex: "replace_bonus_money",
          key: "replace_bonus_money",
          slots: {
            title: "replace_bonus_money",
            customRender: "replace_bonus_moneys",
          },
        },
        {
          title: "余额",
          dataIndex: "balance",
          key: "balance",
        },
        {
          title: "操作",
          dataIndex: "mark",
          slots: { customRender: "mark" },
        },
      ],
    });
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
      getType(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, size) => {
      search.value.page = 1;
      search.value.limit = size;
      initData(search.value);
    };

    const getType = async () => {
      let res = await getBrandBillsType({ ...search.value }).then(
        (res) => res.data
      );
      if ($iscode(res)) {
        state.typeLits = res.data;
      } else {
        message.error(res.msg);
      }
    };
    //列表
    const initData = async (values) => {
      state.listLoading = true;
      try {
        let res = await getDillStatistics(values).then((res) => res.data);
        state.listLoading = false;
        if ($iscode(res)) {
          state.dataSource = res.data.data;
          total.value = res.data.total;
        } else {
          message.error(res.message);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
    //导出
    const exportTable = async () => {
      const hide = message.loading("正在加载中...", 0);
      let result = await exportBillStatistics({ ...search.value })
        .then((res) => res.data)
        .catch((error) => error);
      if ($iscode(result, true)) {
        window.open(config.baseUrl[process.env.VUE_APP_type] + result.data);
      }
      setTimeout(hide);
    };
    const onChange = (e) => {
      if (e.length > 0) {
        search.value.start_time = e[0];
        search.value.end_time = e[1];
      } else {
        search.value.start_time = "";
        search.value.end_time = "";
      }
    };
    // 排序
    const sort = (e) => {
      console.log(e);
      state.isClicked = !state.isClicked;
      search.value.sort_recharge_money = e;
      initData(search.value);
      search.value.sort_recharge_money = ''
    };
    const consume = (e) => {
      state.isClickedtwo = !state.isClickedtwo;
      search.value.sort_consume_money = e;
      initData(search.value);
      search.value.sort_consume_money = ''
    };
    const issuing = (e) => {
      search.value.sort_replace_bonus_money = e;
      state.isClickedthree = !state.isClickedthree;
      initData(search.value);
      search.value.sort_replace_bonus_money = '';
    };
    onMounted(() => {
      initData(search.value);
      getType();
    });
    return {
      ...toRefs(state),
      initData,
      search,
      total,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      onChange,
      exportTable,
      sort, //充值金额排序
      consume, //消耗金额排序
      issuing  //代发金额排序
    };
  },
};
</script>

<style lang="less"></style>
